import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
import { forwardRef as h } from "react";
import { B as m } from "./Button-DQ5ID5KN.js";
import { A as f, a as r } from "./Avatar-CBn18ztW.js";
const b = "320px", H = "600px", u = "1025px", p = "_isVisuallyHidden_ncbe1_51", B = "_oddsButton_ncbe1_63", z = "_oddsContainer_ncbe1_70", _ = "_line_ncbe1_77", S = "_odds_ncbe1_63", W = "_withLine_ncbe1_93", e = {
  mobile: b,
  "mobile-wide": "480px",
  tablet: H,
  "tablet-wide": "800px",
  desktop: u,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: p,
  oddsButton: B,
  oddsContainer: z,
  line: _,
  odds: S,
  withLine: W
}, w = h(
  ({
    bookieColour: s,
    bookieLogo: l,
    bookieName: n,
    className: c = "",
    line: i,
    odds: d,
    selected: a = !1,
    ...y
  }, g) => /* @__PURE__ */ o(
    m,
    {
      className: x(e.oddsButton, c),
      variant: a ? "secondary" : "default",
      ref: g,
      ...y,
      title: n,
      children: [
        /* @__PURE__ */ t(f, { size: "small", style: { backgroundColor: s }, children: /* @__PURE__ */ t(r, { alt: `${n} logo`, src: l }) }),
        /* @__PURE__ */ o("div", { className: e.oddsContainer, children: [
          i && /* @__PURE__ */ t("span", { className: e.line, children: i }),
          /* @__PURE__ */ t("span", { className: x(e.odds, i ? e.withLine : ""), children: d })
        ] })
      ]
    }
  )
);
w.displayName = "OddsButton";
export {
  w as O
};
